<app-legal-layout [title]="title" [lastUpdated]="lastUpdated">
  <h2>1. Productos y Pedidos</h2>
  
  <h3>¿Qué tipos de velas ofrecen?</h3>
  <p>
    Ofrecemos una amplia variedad de velas artesanales hechas con cera de soja premium:
  </p>
  <ul>
    <li>Velas de cera de soja clásicas</li>
    <li>Velas aromáticas artesanales (múltiples fragancias)</li>
    <li>Velas decorativas con diseños únicos</li>
    <li>Velas personalizadas (consultar disponibilidad)</li>
  </ul>

  <h3>¿Qué hace que sus velas sean especiales?</h3>
  <p>
    Nuestras velas están hechas artesanalmente con cera de soja 100% natural, lo que significa:
  </p>
  <ul>
    <li>Queman más limpiamente sin hollín</li>
    <li>Son ecológicas y sostenibles</li>
    <li>Duran hasta un 50% más que velas convencionales</li>
    <li>Conservan mejor los aromas</li>
    <li>Cada pieza es única y hecha a mano en Argentina</li>
  </ul>

  <h3>¿Los productos son hechos a mano?</h3>
  <p>
    Sí, todas nuestras velas son cuidadosamente elaboradas a mano en Buenos Aires y Baradero, 
    asegurando calidad y atención al detalle en cada pieza.
  </p>

  <h3>¿Puedo personalizar una vela?</h3>
  <p>
    Sí, ofrecemos opciones de personalización. Contáctenos a <strong>info@velas.ar</strong> o por WhatsApp 
    al <strong>+54 9 3329-564190</strong> para discutir sus necesidades específicas.
  </p>

  <h2>2. Pedidos y Pagos</h2>

  <h3>¿Cómo realizo un pedido?</h3>
  <p>
    Puede realizar su pedido visitando nuestra tienda online en <a href="https://tienda.velas.ar">tienda.velas.ar</a>. 
    Seleccione los productos deseados, complete sus datos y elija el método de pago.
  </p>

  <h3>¿Qué métodos de pago aceptan?</h3>
  <ul>
    <li>Transferencia bancaria</li>
    <li>Tarjetas de crédito y débito (Visa, Mastercard, American Express)</li>
    <li>Mercado Pago</li>
    <li>Otros métodos de pago digitales</li>
  </ul>

  <h3>¿Los precios incluyen IVA?</h3>
  <p>
    Todos los precios mostrados en nuestro sitio web son en pesos argentinos (ARS). Los impuestos aplicables 
    se mostrarán claramente durante el proceso de pago.
  </p>

  <h3>¿Cuándo se procesa mi pago?</h3>
  <p>
    El pago se procesa cuando realiza el pedido. Recibirá una confirmación por correo electrónico 
    una vez que su pedido haya sido procesado exitosamente.
  </p>

  <h3>¿Recibiré confirmación de mi pedido?</h3>
  <p>
    Sí, recibirá un correo electrónico de confirmación con los detalles de su pedido y un número de seguimiento 
    una vez que procesemos su compra.
  </p>

  <h2>3. Envíos y Entregas</h2>

  <h3>¿A dónde realizan envíos?</h3>
  <ul>
    <li><strong>Buenos Aires:</strong> Capital y Gran Buenos Aires</li>
    <li><strong>Baradero:</strong> Entrega local disponible</li>
    <li><strong>Argentina:</strong> Envío nacional a todo el país</li>
  </ul>

  <h3>¿Cuánto tardan los envíos?</h3>
  <ul>
    <li><strong>Procesamiento:</strong> 3-5 días hábiles</li>
    <li><strong>Buenos Aires:</strong> 1-3 días hábiles adicionales</li>
    <li><strong>Resto de Argentina:</strong> 5-10 días hábiles adicionales</li>
  </ul>
  <p><em>*Los tiempos pueden variar según la temporada y condiciones climáticas</em></p>

  <h3>¿Cuánto cuesta el envío?</h3>
  <p>
    Los costos de envío se calculan automáticamente según el destino y peso del pedido. 
    Se mostrarán claramente durante el proceso de compra antes de confirmar su pedido.
  </p>

  <h3>¿Puedo hacer seguimiento de mi pedido?</h3>
  <p>
    Sí, una vez que su pedido sea despachado, recibirá un correo electrónico con un número de seguimiento 
    que podrá utilizar para rastrear su paquete.
  </p>

  <h3>¿Qué hago si mi pedido llega dañado?</h3>
  <p>
    Si su pedido llega dañado, contáctenos inmediatamente al <strong>info@velas.ar</strong> o por WhatsApp 
    al <strong>+54 9 3329-564190</strong>. Tomaremos fotos del daño y le enviaremos un reemplazo sin costo adicional.
  </p>

  <h2>4. Devoluciones y Reembolsos</h2>

  <h3>¿Puedo devolver un producto?</h3>
  <p>
    Sí, aceptamos devoluciones dentro de 10 días calendario desde la recepción del producto. 
    Para más detalles, consulte nuestra <a routerLink="/devoluciones">Política de Devoluciones</a>.
  </p>

  <h3>¿Cuánto tarda el reembolso?</h3>
  <p>
    Una vez que recibamos y procesemos su devolución, el reembolso puede tardar entre 5 a 10 días hábiles 
    en aparecer en su cuenta.
  </p>

  <h3>¿Aceptan cambios de productos?</h3>
  <p>
    Sí, aceptamos cambios por diferentes tamaños o productos dentro del período de devolución. 
    El cliente cubre los costos de envío del producto original de regreso.
  </p>

  <h2>5. Uso y Cuidado de las Velas</h2>

  <h3>¿Cómo debo cuidar mis velas de soja?</h3>
  <ul>
    <li>Primera quemada: Deje que la cera se derrita completamente hasta los bordes (2-3 horas)</li>
    <li>Recorte la mecha a 5mm antes de cada uso</li>
    <li>No deje la vela encendida por más de 4 horas consecutivas</li>
    <li>Guárdelas en un lugar fresco y seco, lejos de la luz solar directa</li>
    <li>Manténgalas fuera del alcance de niños y mascotas</li>
  </ul>

  <h3>¿Por cuánto tiempo arden las velas?</h3>
  <p>
    El tiempo de combustión varía según el tamaño de la vela. En general, nuestras velas de cera de soja 
    duran un 50% más que las velas convencionales. Puede esperar:
  </p>
  <ul>
    <li><strong>Velas pequeñas (100g):</strong> 20-25 horas</li>
    <li><strong>Velas medianas (200g):</strong> 40-50 horas</li>
    <li><strong>Velas grandes (400g):</strong> 80-100 horas</li>
  </ul>

  <h3>¿Son seguras las velas de cera de soja?</h3>
  <p>
    Sí, nuestras velas están hechas con cera de soja 100% natural, que es más segura que la parafina tradicional. 
    Queman más limpiamente sin liberar químicos tóxicos. Sin embargo, siempre debe:
  </p>
  <ul>
    <li>Nunca dejar una vela desatendida mientras está encendida</li>
    <li>Mantener las velas alejadas de materiales inflamables</li>
    <li>Colocar las velas en una superficie estable y resistente al calor</li>
  </ul>

  <h2>6. Información de Contacto</h2>

  <h3>¿Cómo puedo contactarlos?</h3>
  <p>Puede contactarnos a través de:</p>
  <ul>
    <li><strong>Email:</strong> info@velas.ar</li>
    <li><strong>Teléfono:</strong> +54 9 3329-564190</li>
    <li><strong>WhatsApp:</strong> <a href="https://wa.me/5493329564190">+54 9 3329-564190</a></li>
    <li><strong>Redes Sociales:</strong></li>
    <ul>
      <li>Instagram: <a href="https://www.instagram.com/velas.ar_mayorista/">@velas.ar_mayorista</a></li>
      <li>TikTok: <a href="https://www.tiktok.com/@velas.ar_mayorista">@velas.ar_mayorista</a></li>
      <li>YouTube: <a href="https://www.youtube.com/@velas.ar_mayorista">@velas.ar_mayorista</a></li>
      <li>Pinterest: <a href="https://ar.pinterest.com/velas_ar_mayorista/">velas_ar_mayorista</a></li>
    </ul>
  </ul>

  <h3>¿Cuáles son sus horarios de atención?</h3>
  <p>
    Nuestro equipo de atención al cliente está disponible de lunes a viernes de 9:00 AM a 6:00 PM (hora de Argentina). 
    Los fines de semana respondemos consultas a través de WhatsApp.
  </p>

  <h3>¿Hacen pedidos al por mayor?</h3>
  <p>
    Sí, ofrecemos precios especiales para pedidos al por mayor. Contáctenos para discutir cantidades, 
    precios y opciones de personalización.
  </p>

  <h2>7. Información Adicional</h2>

  <h3>¿Dónde están ubicados?</h3>
  <p>
    Nos ubicamos en Baradero, Buenos Aires, Argentina. Nuestros productos están hechos a mano localmente 
    y distribuidos en todo el país.
  </p>

  <h3>¿Sus productos son ecológicos?</h3>
  <p>
    Sí, nuestras velas están hechas con cera de soja 100% natural, una alternativa ecológica y sostenible 
    a la parafina tradicional. Nuestros productos son libres de químicos tóxicos.
  </p>

  <h3>¿Ofrecen descuentos o promociones especiales?</h3>
  <p>
    Sí, regularmente ofrecemos promociones especiales y descuentos. Para mantenerse actualizado, 
    síganos en nuestras redes sociales o suscríbase a nuestro boletín.
  </p>

  <div style="margin-top: 3rem; padding: 2rem; background: #f5f5f5; border: 2px solid #ad5d56;">
    <h3>¿No encontró su respuesta?</h3>
    <p>
      Si tiene alguna pregunta adicional, no dude en contactarnos. Estamos aquí para ayudar y asegurarnos 
      de que tenga la mejor experiencia posible.
    </p>
    <p style="margin-bottom: 0;">
      <strong>Email:</strong> info@velas.ar | 
      <strong>WhatsApp:</strong> <a href="https://wa.me/5493329564190">+54 9 3329-564190</a>
    </p>
  </div>
</app-legal-layout>

